import { render, staticRenderFns } from "./BusinessDashboardView.vue?vue&type=template&id=62448b8c"
import script from "./BusinessDashboardView.vue?vue&type=script&lang=js"
export * from "./BusinessDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports